import { workoutDisplayDigits as displayDigits } from '../../utils/workoutNumberFormat';
import '../../styles/workout-detail-system.css';
import { useEffect, useRef, useState, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { NmTabNav } from '../../components/NmTabNav';
import '../../styles/workout-analysis-details.css';

/** Full-height details card; the workout page owns vertical scrolling. */
export function WorkoutAnalysisDetails({ statistics, laps, selected, onClear, statsTitle, statsRequest }: {
  statistics: ReactNode; laps: ReactNode;
  selected: string | null; onClear: () => void;
  statsTitle?: string; statsRequest?: number;
}) {
  const { t } = useTranslation();
  const [tab, setTab] = useState('stats');
  const panel = useRef<HTMLElement>(null);
  useEffect(() => {
    if (!statsRequest) return;
    setTab('stats');
    panel.current?.scrollIntoView({ block: 'start' });
  }, [statsRequest]);
  return (
    <section ref={panel} className="wa-details" aria-label={t('workoutDetail.map.detailsTitle')}>
      <header className="wa-details__heading"><h3>{t('workoutDetail.map.detailsTitle')}</h3></header>
      {selected && <div className="wa-details__selection"><span>{displayDigits(selected)}</span><button type="button" onClick={onClear}>{t('workoutDetail.map.showWholeWorkout')}</button></div>}
      <NmTabNav items={[
        { value: 'stats', label: statsTitle || t('workoutDetail.map.statsTab') },
        { value: 'laps', label: t('workoutDetail.map.pickerLaps') },
      ]} value={tab} onChange={value => { setTab(value); }} ariaLabel={t('workoutDetail.map.detailsTitle')} idBase="wa-details-tab" panelId="wa-details-content" />
      <div className="wa-details__body" id="wa-details-content" role="tabpanel" aria-labelledby={`wa-details-tab-${tab}`}>
        {tab === 'stats' ? statistics : laps}
      </div>
    </section>
  );
}
